// Suppress ResizeObserver errors immediately
const resizeObserverLoopErr =
  "ResizeObserver loop completed with undelivered notifications.";
const resizeObserverLoopLimit = "ResizeObserver loop limit exceeded";

const isResizeObserverError = (err) => {
  const msg = typeof err === "string" ? err : err?.message;
  return (
    msg &&
    (msg.includes(resizeObserverLoopErr) ||
      msg.includes(resizeObserverLoopLimit) ||
      msg.includes("ResizeObserver loop"))
  );
};

// Override window.onerror
const originalOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (isResizeObserverError(message)) {
    return true;
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

// Add event listener for error
window.addEventListener("error", (e) => {
  if (isResizeObserverError(e) || isResizeObserverError(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

// Suppress from console.error before other imports
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args.length > 0 && isResizeObserverError(args[0])) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Add handler for unhandled rejections
window.addEventListener("unhandledrejection", (e) => {
  if (isResizeObserverError(e.reason)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
